import { Main as MainLayout, Minimal as MinimalLayout } from "./layouts";
import React, { Suspense, lazy } from "react";
import { Redirect, Switch } from "react-router-dom";

import { LoadingScreen } from "./components";
import { RouteWithLayout } from "./components";
import config from "config/main";

const NotFoundView = lazy(() => import("./views/NotFound"));

const AppointmentsView = lazy(() => import("./views/Appointments"));
const ProfileView = lazy(() => import("./views/Profile"));
const SettingsView = lazy(() => import("./views/Settings"));
const PatientsView = lazy(() => import("./views/Patients"));
const FinancesView = lazy(() => import("./views/Finances"));
const AuthenticationView = lazy(() => import("./views/Authentication"));
const LandingPageView = lazy(() => import("./views/LandingPage"));
const CreateAccountWelcomeView = lazy(() => import("./views/CreateAccountWelcome"));
const TeleConsultView = lazy(() => import("./views/TeleConsult"));
const HAYFTView = lazy(() => import("./views/HAYFT"));

const pageData = config.pageData;

const getView = (view, isEnabled) => {
  if (isEnabled) {
    return view;
  } else {
    return NotFoundView;
  }
};

const Routes = () => {
  return (
    <Suspense fallback={<LoadingScreen />}>
      <Switch>
        <RouteWithLayout
          exact
          component={getView(
            LandingPageView,
            pageData.LandingPage.route.isEnabled
          )}
          layout={MainLayout}
          path={pageData.LandingPage.route.path}
          onlyAuthUsers={pageData.LandingPage.route.onlyAuthUsers}
        />
        <RouteWithLayout
          exact
          component={getView(AuthenticationView, pageData.Login.route.isEnabled)}
          layout={MainLayout}
          path={pageData.Login.route.path}
          onlyAuthUsers={pageData.Login.route.onlyAuthUsers}
        />
        <RouteWithLayout
          exact
          component={getView(AuthenticationView, pageData.Register.route.isEnabled)}
          layout={MainLayout}
          path={pageData.Register.route.path}
          onlyAuthUsers={pageData.Login.route.onlyAuthUsers}
        />
        <RouteWithLayout
          exact
          component={getView(CreateAccountWelcomeView, pageData.CreateAccountWelcome.route.isEnabled)}
          layout={MainLayout}
          path={pageData.CreateAccountWelcome.route.path}
          onlyAuthUsers={pageData.CreateAccountWelcome.route.onlyAuthUsers}
        />
        <RouteWithLayout
          exact
          component={getView(AuthenticationView, pageData.ForgotPassword.route.isEnabled)}
          layout={MainLayout}
          path={pageData.ForgotPassword.route.path}
          onlyAuthUsers={pageData.ForgotPassword.route.onlyAuthUsers}
        />
        <RouteWithLayout
          exact
          component={getView(
            AppointmentsView,
            pageData.Appointments.route.isEnabled
          )}
          layout={MainLayout}
          path={pageData.Appointments.route.path}
          onlyAuthUsers={pageData.Appointments.route.onlyAuthUsers}
        />
        <RouteWithLayout
          exact
          component={getView(
            ProfileView,
            pageData.Profile.route.isEnabled
          )}
          layout={MainLayout}
          path={pageData.Profile.route.path}
          onlyAuthUsers={pageData.Profile.route.onlyAuthUsers}
        />
        <RouteWithLayout
          exact
          component={getView(
            SettingsView,
            pageData.Settings.route.isEnabled
          )}
          layout={MainLayout}
          path={pageData.Settings.route.path}
          onlyAuthUsers={pageData.Settings.route.onlyAuthUsers}
        />
        <RouteWithLayout
          exact
          component={getView(PatientsView, pageData.Patients.route.isEnabled)}
          layout={MainLayout}
          path={pageData.Patients.route.path}
          onlyAuthUsers={pageData.Patients.route.onlyAuthUsers}
        />
        <RouteWithLayout
          exact
          component={getView(FinancesView, pageData.Finances.route.isEnabled)}
          layout={MainLayout}
          path={pageData.Finances.route.path}
          onlyAuthUsers={pageData.Finances.route.onlyAuthUsers}
        />
        <RouteWithLayout
          exact
          component={getView(TeleConsultView, pageData.TeleConsult.route.isEnabled)}
          layout={MainLayout}
          path={pageData.TeleConsult.route.path}
          onlyAuthUsers={pageData.TeleConsult.route.onlyAuthUsers}
        />
        <RouteWithLayout
          exact
          component={getView(HAYFTView, pageData.HAYFT.route.isEnabled)}
          layout={MainLayout}
          path={pageData.HAYFT.route.path}
          onlyAuthUsers={pageData.HAYFT.route.onlyAuthUsers}
        />
        <RouteWithLayout
          component={NotFoundView}
          exact
          layout={MainLayout}
          path={pageData.NotFound.route.path}
          onlyAuthUsers={pageData.NotFound.route.onlyAuthUsers}
        />
        <Redirect to={pageData.NotFound.route.path} />
      </Switch>
    </Suspense>
  );
};

export default Routes;
